import { useState } from "react";
import { ModalShell } from "./ModalShell";

/** Set-PIN modal for per-chat locks — replaces window.prompt (native-shell safe). */
export function ChatLockPromptModal({
  title,
  onClose,
  onConfirm,
}: {
  title: string;
  onClose: () => void;
  onConfirm: (pin: string) => void;
}) {
  const [pin, setPin] = useState("");
  const [err, setErr] = useState<string | null>(null);

  function submit() {
    if (pin.length < 4) {
      setErr("PIN must be at least 4 characters");
      return;
    }
    onConfirm(pin);
  }

  return (
    <ModalShell
      title="Lock chat"
      ariaLabel="Set chat lock PIN"
      onClose={onClose}
      size="sm"
      className="add-contact-card"
      footer={
        <div className="actions-row">
          <button type="button" className="btn secondary" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn" onClick={submit}>
            Enable
          </button>
        </div>
      }
    >
      <div className="stack">
        <p className="muted">
          Set a local PIN for <strong>{title}</strong>. Veto will ask for it before opening this
          chat. This lock is local-only — not end-to-end encryption.
        </p>
        <div className="field">
          <label htmlFor="chatLockNewPin">PIN</label>
          <input
            id="chatLockNewPin"
            type="password"
            inputMode="numeric"
            autoComplete="new-password"
            value={pin}
            onChange={(e) => {
              setPin(e.target.value);
              setErr(null);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") submit();
            }}
            autoFocus
          />
        </div>
        {err && (
          <p className="text-danger" role="alert">
            {err}
          </p>
        )}
      </div>
    </ModalShell>
  );
}
